import mParticle from "@mparticle/web-sdk"

// TODO Handle add blockers

export default class {
  constructor(el, options) {
    mParticle.init("eu1-d3ef58367bbc8d4182692e0b966c2159", {
      appName: "10chambers.com",
      appVersion: "0.0.1",
      isDevelopmentMode: options?.debug,
      logLevel: options?.debug ? "verbose" : "warning",
    })

    mParticle.ready(() => {
      this.pageView()
    })

    this.newsletterForm()
    this.newsletterSettings()
    // this.outboundLinks()
  }

  outboundLinks() {
    document.addEventListener("click", (e) => {
      if (e.target.tagName === "A" && e.target.href.startsWith("http")) {
        mParticle.logEvent("Outbound link", mParticle.EventType.Navigation, {
          label: e.target.textContent,
          url: e.target.href,
          page: window.location.toString(),
          "referring-page": document.referrer,
        })
      }
    })
  }

  pageView() {
    const pageTitle = document.title.split(" - ").shift()

    mParticle.logPageView(pageTitle, {
      page: window.location.toString(),
      "referring-page": document.referrer,
    })
  }

  newsletterSettings() {
    const newsletterSettingsForm = document.querySelector(
      ".js-newsletterSettings",
    )

    if (newsletterSettingsForm) {
      const messageEl = newsletterSettingsForm.querySelector(
        ".js-newsletterSettingsMessage",
      )
      const unusbscribeCheckEl = newsletterSettingsForm.querySelector(
        ".js-newsletterSettingsUnsubscribe",
      )
      const otherCheckboxes = Array.from(
        newsletterSettingsForm.querySelectorAll('input[type="checkbox"]'),
      ).filter((el) => el !== unusbscribeCheckEl)

      unusbscribeCheckEl.addEventListener("change", (e) => {
        if (e.target.checked) {
          otherCheckboxes.forEach((el) => {
            if (el !== e.target) {
              el.checked = false
            }
          })
        }
      })

      otherCheckboxes.forEach((el) => {
        el.addEventListener("change", (e) => {
          if (e.target.checked) {
            unusbscribeCheckEl.checked = false
          }
        })
      })

      newsletterSettingsForm.addEventListener("submit", (e) => {
        e.preventDefault()

        messageEl.textContent = ""
        messageEl.setAttribute("hidden", true)

        if (!mParticle.isInitialized()) {
          messageEl.textContent = "Failed to connect to our newsletter services"
          messageEl.removeAttribute("hidden")

          return
        }

        const data = new FormData(e.target)
        const email = data.get("email")
        const gtfo = data.get("gtfo")
        const dow = data.get("dow")
        const tenChambers = data.get("10chambers")
        const unsubscribe = data.get("unsubscribe")

        if (email) {
          try {
            mParticle.Identity.login(
              {
                userIdentities: {
                  email: email,
                },
              },
              function () {
                mParticle.logEvent(
                  "Newsletter preferences",
                  mParticle.EventType.Other,
                  {
                    email,
                    gtfo: unsubscribe ? false : gtfo ? true : false,
                    dow: unsubscribe ? false : dow ? true : false,
                    "10chambers": unsubscribe
                      ? false
                      : tenChambers
                      ? true
                      : false,
                  },
                )

                messageEl.textContent = "Your preferences has been saved."
                messageEl.removeAttribute("hidden")
              },
            )
          } catch (error) {
            messageEl.textContent = "Something went wrong. Please try again."
            messageEl.removeAttribute("hidden")
          }
        }

        return false
      })
    }
  }

  newsletterForm() {
    const newsletterForm = document.querySelector(".js-newsletterForm")
    const messageEl = newsletterForm.querySelector(".js-newsletterMessage")

    if (newsletterForm) {
      newsletterForm.addEventListener("submit", (e) => {
        e.preventDefault()

        messageEl.textContent = ""
        messageEl.setAttribute("hidden", true)

        if (!mParticle.isInitialized()) {
          messageEl.textContent = "Failed to connect to our newsletter services"
          messageEl.removeAttribute("hidden")

          return
        }

        const data = new FormData(e.target)
        const email = data.get("email")

        if (email) {
          try {
            mParticle.Identity.login(
              {
                userIdentities: {
                  email: email,
                },
              },
              function () {
                mParticle.logEvent(
                  "Newsletter signup",
                  mParticle.EventType.Other,
                  {
                    label: "Website footer",
                    page: window.location.toString(),
                    "referring-page": document.referrer,
                  },
                )

                messageEl.textContent = "You have been subscribed."
                messageEl.removeAttribute("hidden")
              },
            )
          } catch (error) {
            messageEl.textContent = "Something went wrong. Please try again."
            messageEl.removeAttribute("hidden")
          }
        }

        return false
      })
    }
  }
}
